module.exports = __webpack_public_path__ + "8c29b8851eb26b26ae7ee2de344a266a.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/People/Board_Jonas_Eriksson_web.jpg
// module id = 157
// module chunks = 0